
import { defineComponent } from 'vue'
import { useRouter } from 'vue-router'
import PRBadge from '../elements/PRBadge.vue'

export default defineComponent({
  name: 'HomeRecommendSpecialCard',

  components: {
    PRBadge
  },

  props: {
    image: String,
    imageAlt: {
      type: String,
      default: ''
    },
    category: String,
    heading: String,
    url: String,
    path: {
      type: String,
      default: '/'
    },
    showPr: {
      type: Boolean,
      default: false
    }
  },

  setup(props) {
    const router = useRouter()

    const onClick = (e: MouseEvent) => {
      if (props.url) return true
      if (e.ctrlKey || e.metaKey) return true

      e.preventDefault()
      return router.push(props.path)
    }

    return {
      onClick
    }
  }
})
